<div class="row">
	<div class="col-xl-3 col-md-3  px-2 pb-3" *ngFor="let instrument of instruments">
		<kt-instrument-card1
			[instrument]="instrument"
			(view)="view.emit($event)"
		></kt-instrument-card1>
	</div>
</div>
